var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard1Img(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 144,
    viewBox: "0 0 193 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    width: 54,
    height: 54,
    fill: "#1AD079"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    width: 54,
    height: 54,
    fill: "#1AD079"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 125.5,
    width: 30,
    height: 30,
    fill: "#07133B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 162.5,
    width: 30,
    height: 30,
    fill: "#07133B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 162.5,
    y: 38,
    width: 30,
    height: 30,
    fill: "#07133B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 125.5,
    y: 38,
    width: 30,
    height: 30,
    fill: "#07133B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 125.5,
    y: 76,
    width: 30,
    height: 30,
    fill: "#6A7189"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 162.5,
    y: 76,
    width: 30,
    height: 30,
    fill: "#6A7189"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 62,
    width: 54,
    height: 54,
    fill: "#1AD079"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 62,
    width: 54,
    height: 54,
    fill: "#1AD079"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 116.5C38.3333 138.833 128.7 168.2 191.5 107",
    stroke: "#1AD079",
    strokeDasharray: "5 5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1Img);
export default __webpack_public_path__ + "static/media/card_1img.4c08bbd64a4156d48782a7dea91b9e4e.svg";
export { ForwardRef as ReactComponent };